import Hexasign from "../new_sign/Hexasign";

const PdfEditor = ({
  folder,
  document,
  rapport,
  file_url = null,
  onClose,
  onFetch,
  rt_batiment = false,
  operator_id = null,
  mode = "choice",
  from_extract = false,
  userData = null,
  fileName = null,
}) => {
  return (
    <Hexasign
      file_url={file_url}
      document={document}
      folder={folder}
      rapport={rapport}
      onClose={onClose}
      onFetch={onFetch}
      rt_batiment={rt_batiment}
      operator_id={operator_id}
      mode={mode}
      from_extract={from_extract}
      userData={userData}
      fileName={fileName}
    />
  );
};
export default PdfEditor;
